import React from "react"
import { Link } from "gatsby"

import { Analytics } from "@shared"

import { URLS } from "@data"
import { featureFlag } from "@jsUtils"

const AnalyticsLink = Analytics(Link)

/**
 * Secondary navigation items
 * Re-used by the footer
 * @param {object} - props - react props
 * @param {boolean} - props.hidden - hidden from screen readers
 * @param {string} - props.className - css class name
 * @param {string} - props.analytics - ANALYTICS scope name
 * @paraa {object|array} - props.children - child react nodes
 */
const NavSecondary = ({ analytics, className, hidden, children }) => {
  const tabbing = hidden ? -1 : 0

  const animationSequence = []
  // Set the loop terminus high enough to handle max list items
  for (let i = 1; i < 30; i++) {
    animationSequence.push(i)
  }

  return (
    <>
      <ul className={className}>
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.RESOURCES"
            to={URLS.RESOURCES}
            tabIndex={tabbing}
          >
            Resources
          </AnalyticsLink>
        </li>
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.NEWSROOM"
            to={URLS.NEWSROOM}
            tabIndex={tabbing}
          >
            Newsroom
          </AnalyticsLink>
        </li>
        {featureFlag("link.ourPeople") && (
          <li style={{ "--animation-position": animationSequence.shift() }}>
            <AnalyticsLink
              ascope={analytics}
              adata="NAV.PEOPLE"
              to={URLS.OUR_PEOPLE}
              tabIndex={tabbing}
            >
              Our People
            </AnalyticsLink>
          </li>
        )}
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.CAREERS"
            to={URLS.CAREERS}
            tabIndex={tabbing}
          >
            Careers
          </AnalyticsLink>
        </li>
        {featureFlag("link.support") && (
          <li style={{ "--animation-position": animationSequence.shift() }}>
            <AnalyticsLink
              ascope={analytics}
              adata="NAV.SUPPORT"
              to={URLS.SUPPORT()}
              tabIndex={tabbing}
              target="zendesk"
            >
              Support
            </AnalyticsLink>
          </li>
        )}
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.CONTACT"
            to={URLS.CONTACT}
            tabIndex={tabbing}
          >
            Contact
          </AnalyticsLink>
        </li>
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.INVESTORS"
            to={URLS.INVESTORS}
            tabIndex={tabbing}
          >
            Investors
          </AnalyticsLink>
        </li>
        {featureFlag("link.styleguide") && (
          <li style={{ "--animation-position": animationSequence.shift() }}>
            <AnalyticsLink to={URLS.STYLEGUIDE} tabIndex={tabbing}>
              Styleguide
            </AnalyticsLink>
          </li>
        )}
        {!!children && (
          <li style={{ "--animation-position": animationSequence.shift() }}>{children}</li>
        )}
      </ul>
    </>
  )
}

export default NavSecondary
